// Panel state for the eye test scene: a module singleton holding the gaze REQUEST only.

import { DEFAULT_GAZE_LIMITS, clampYawPitch } from '../ogs/eyes/index.ts'

export const eyeTestState = {
  // 'manual' = yaw/pitch sliders, 'camera' = look at the live viewport camera.
  mode: 'manual',
  perEye: false,
  limits: { ...DEFAULT_GAZE_LIMITS },
  gaze: {
    left: { yawDegrees: 0, pitchDegrees: 0 },
    right: { yawDegrees: 0, pitchDegrees: 0 },
  },
  // `headSplats` only does anything under ?head=1 — the head branch is not mounted otherwise.
  show: {
    headWire: true, eyePoints: false, arrows: true, pivots: true, splats: true, eyeMesh: false,
    headSplats: true,
  },
  // Written by the scene each frame, so camera mode resolves outside the render loop.
  cameraPosition: [0, 1.38, 0.4],
}

const subscribers = new Set()
let version = 0

export function subscribeEyeTest(listener) {
  subscribers.add(listener)
  return () => subscribers.delete(listener)
}

export const eyeTestVersion = () => version

function notify() {
  version++
  for (const listener of subscribers) listener()
}

export function setEyeTest(patch) {
  Object.assign(eyeTestState, patch)
  notify()
}

export function setGaze(side, yawDegrees, pitchDegrees) {
  const clamped = clampYawPitch({ yawDegrees, pitchDegrees }, eyeTestState.limits)
  if (side === 'both') {
    eyeTestState.gaze.left = { ...clamped }
    eyeTestState.gaze.right = { ...clamped }
  } else {
    eyeTestState.gaze[side] = { ...clamped }
  }
  notify()
}

export function resetEyeTest() {
  eyeTestState.mode = 'manual'
  eyeTestState.perEye = false
  setGaze('both', 0, 0)
}

/** The ONE place the panel's state becomes a gaze, so the render loop and the debug seam agree. */
export function applyGazeRequest(controller) {
  if (eyeTestState.mode === 'camera') {
    controller.gaze.lookAtPoint(eyeTestState.cameraPosition)
    return
  }
  const { left, right } = eyeTestState.gaze
  controller.gaze.setYawPitch(eyeTestState.perEye ? { left, right } : left)
}
